'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var Tabs$1 = require('../../../node_modules/@material-ui/core/esm/Tabs/Tabs.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _VERTICAL_TAB_HEIGHTS;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var WIDTH_INDICATOR = 2;
var SIZE_EX_SMALL = 'xs';
var SIZE_SMALL = 'sm';
var SIZE_MEDIUM = 'med';
var SIZE_LARGE = 'lg';
var SIZES_MEDIUM_PLUS = [SIZE_MEDIUM, SIZE_LARGE];
var VERTICAL_TAB_HEIGHTS = (_VERTICAL_TAB_HEIGHTS = {}, defineProperty(_VERTICAL_TAB_HEIGHTS, SIZE_EX_SMALL, 32), defineProperty(_VERTICAL_TAB_HEIGHTS, SIZE_SMALL, 40), defineProperty(_VERTICAL_TAB_HEIGHTS, SIZE_MEDIUM, 48), defineProperty(_VERTICAL_TAB_HEIGHTS, SIZE_LARGE, 56), _VERTICAL_TAB_HEIGHTS);
var useStyles = makeStyles["default"](function (theme) {
  return {
    horizontalIndicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      bottom: '10px',
      '& > span': {
        width: '16px',
        height: '2px',
        backgroundColor: theme.palette.primary.contrastText,
        borderRadius: '2px'
      }
    },
    indicatorVertical: function indicatorVertical(_ref) {
      var tabSize = _ref.tabSize;
      var tabHeight = VERTICAL_TAB_HEIGHTS[tabSize];
      var indicatorHeight = SIZES_MEDIUM_PLUS.includes(tabSize) ? theme.spacing(3) : theme.spacing(2);
      return {
        left: theme.spacing(1.5),
        marginTop: (tabHeight - indicatorHeight) / 2,
        maxHeight: indicatorHeight
      };
    },
    flexContainerVertical: function flexContainerVertical(_ref2) {
      var tabSize = _ref2.tabSize;
      return {
        '& > .Mui-selected': {
          transition: 'padding-left 0.5s',
          paddingLeft: theme.spacing(3.25) + WIDTH_INDICATOR
        },
        '& > [role=tab]': {
          minHeight: VERTICAL_TAB_HEIGHTS[tabSize],
          height: VERTICAL_TAB_HEIGHTS[tabSize],
          transition: 'padding-left 0.5s',
          maxWidth: '100%',
          '& > span': {
            alignItems: 'flex-start'
          }
        }
      };
    }
  };
});
var HorizontalTabs = React.forwardRef(function (_ref3, ref) {
  var classes = _ref3.classes,
      rest = objectWithoutProperties(_ref3, ["classes"]);

  var _useStyles = useStyles(),
      horizontalIndicator = _useStyles.horizontalIndicator;

  return React__default["default"].createElement(Tabs$1["default"], _objectSpread({
    classes: _objectSpread({
      indicator: horizontalIndicator
    }, classes),
    TabIndicatorProps: {
      children: React__default["default"].createElement("span", null)
    },
    ref: ref
  }, rest));
});
var VerticalTabs = React.forwardRef(function (_ref4, ref) {
  var classes = _ref4.classes,
      tabSize = _ref4.tabSize,
      rest = objectWithoutProperties(_ref4, ["classes", "tabSize"]);

  var _useStyles2 = useStyles({
    tabSize: tabSize
  }),
      indicatorVertical = _useStyles2.indicatorVertical,
      flexContainerVertical = _useStyles2.flexContainerVertical;

  return React__default["default"].createElement(Tabs$1["default"], _objectSpread({
    classes: _objectSpread({
      indicator: indicatorVertical,
      flexContainerVertical: flexContainerVertical
    }, classes),
    ref: ref
  }, rest));
});
var Tabs = React.forwardRef(function (_ref5, ref) {
  var fullWidth = _ref5.fullWidth,
      tabSize = _ref5.tabSize,
      version = _ref5.version,
      rest = objectWithoutProperties(_ref5, ["fullWidth", "tabSize", "version"]);

  if (fullWidth) return React__default["default"].createElement(Tabs$1["default"], _objectSpread({
    variant: "fullWidth",
    ref: ref
  }, rest));

  if (version === 'v2') {
    return rest.orientation === 'vertical' ? React__default["default"].createElement(VerticalTabs, _objectSpread({
      tabSize: tabSize,
      ref: ref
    }, rest)) : React__default["default"].createElement(HorizontalTabs, _objectSpread({
      ref: ref
    }, rest));
  }

  return React__default["default"].createElement(Tabs$1["default"], _objectSpread({
    ref: ref
  }, rest));
});

module.exports = Tabs;
